export default "__VITE_ASSET__CEV0t3Cz__"